import React, { useEffect, useState } from "react";
import Layout from "../components/organisms/layout/layout";
import LibraryComponents from "../components/templates/library-components/libraryComponents";
import { ReferenciaOrganismos } from "../interfaces/ReferenciaOrganismos";
import SEO from "../shared/seo";
import Disclaimer from "../components/molecules/disclaimer/disclaimer";
import Suscribe from "../components/molecules/suscribe/suscribe";
import WhatsappGroup from "../components/molecules/whatsapp-group/whatsappGroup";
import {
  adapterEtiquetas,
  adapterSuscribe,
} from "../components/templates/library-components/adapters";
import Etiquetas from "../components/atoms/etiquetas/etiquetas";
import Related from "../components/organisms/related/Related";
import { dateToRelativeFormat } from "../utils/dateToRelativeFormat";
import { shuffleArray } from "../utils/arrayUtilities";
import { graphql, useStaticQuery } from "gatsby";
import { calculateReadTime } from "../utils/calculateReadTime";

const TemplateEditorial = (props: any) => {
  const pageData = props.pageContext;
  const keyName =
    pageData.referenciaCabecera && pageData.referenciaCabecera.tipoCabecera;
  const pageSlug = props.location.pathname;
  const [related, setRelated] = useState([])

  const data = useStaticQuery(graphql`
  query relatedEditorialsQuery2 {
    allContentfulSubcategoria(
      filter: { tipoContenido: { eq: "Artículo Editorial" } }
    ) {
      nodes {
        titulo
        slug
        tipoContenido
        nombreSubcategoria

        nroEdicion
        nombreSubcategoria
        tipoContenido
        slug
        createdAt
        referenciaInterna {
          referenciaCabecera {
            imagenHeader {
              file {
                url
              }
            }
            descripcion {
              content {
                content {
                  value
                }
              }
            }
          }
        }
      }
    }
  }
`);

  const getRelated = () => {
    if (!data.allContentfulSubcategoria?.nodes) return [];
    const process = data.allContentfulSubcategoria?.nodes.map((item) => ({
      categoria: "Editorial",
      categoriaSlug: "/editoriales",
      descripcion:
        item.referenciaInterna.referenciaCabecera.descripcion?.content[0]
          .content[0].value,
      imagen: item.referenciaInterna.referenciaCabecera.imagenHeader.file.url,
      slug: "editoriales/" + item.slug,
      titulo: item.nombreSubcategoria,
      fecha: dateToRelativeFormat(item.createdAt),
      tiempo: `${calculateReadTime(item.nombreSubcategoria)} minutos`,
    }));
    return shuffleArray(process).slice(0, 3);
  };

  useEffect(() => {
    setRelated(getRelated())
  }, [])

  return (
    <Layout
      hideHeaderDesktop={false}
      hideHeaderMobile={false}
      isNotRoot={true}
      headboard={pageData.referenciaCabecera && pageData.referenciaCabecera}
      showPlayer={true}
      readTime={calculateReadTime(pageData.referenciaCabecera?.tituloPrincipal)}
    >
      <SEO
        title={
          props.pageContext.metaTitulo || props.pageContext.nombreCategoria
        }
        slug={pageSlug}
        description={
          props.pageContext.metaDescripcion &&
          props.pageContext.metaDescripcion.json.content[0].content[0].value
        }
        image={
          props.pageContext.referenciaCabecera.imagenHeader &&
          props.pageContext.referenciaCabecera.imagenHeader.file.url
        }
        lang="es"
      />
      {pageData.referenciaOrganismos &&
        pageData.referenciaOrganismos.map(
          (value: ReferenciaOrganismos, index: number) => (
            <div key={index} className={keyName} id={`${keyName}${index}`}>
              <LibraryComponents
                content={value}
                categoryName={pageData.nombreCategoria}
              />
            </div>
          )
        )}
      <Etiquetas {...adapterEtiquetas(props)} />
      <Related titulo="También te puede <b>interesar</b>" gridElements={related} />
      <WhatsappGroup />
      <Suscribe {...adapterSuscribe()} />
      <Disclaimer />
    </Layout>
  );
};

export default TemplateEditorial;
